import { Col, Pagination, Row, Space } from 'antd';

export default function CustomPagination({
  totalRecord,
  pagination,
  handlePagination,
  notMain = false,
}) {
  const itemRender = (_, type, originalElement) => {
    if (type === 'jump-prev') {
      return <i className='mdi mdi-chevron-double-right'></i>;
    }
    if (type === 'jump-next') {
      return <i className='mdi mdi-chevron-double-left'></i>;
    }
    if (type === 'prev') {
      return <i className='mdi mdi-chevron-right'></i>;
    }
    if (type === 'next') {
      return <i className='mdi mdi-chevron-left'></i>;
    }
    return originalElement;
  };

  return (
    <Row
      style={{
        marginTop: '1rem',
        backgroundColor: notMain ? 'rgb(250, 250, 250, 1)' : 'rgb(255, 255, 255, 0.5)',
        padding: '1rem',
      }}
    >
      <Col xl={12} lg={12} md={12} sm={12} xs={24}>
        <Pagination
          onChange={(newPage, newPageSize) => {
            handlePagination(newPage, newPageSize);
          }}
          defaultPageSize={pagination?.pageSize}
          defaultCurrent={pagination?.page}
          total={totalRecord}
          locale={{ items_per_page: '' }}
          itemRender={itemRender}
          pageSizeOptions={[10, 20, 50, 100, 500, 1000, 2000]}
          showSizeChanger={true}
          responsive
          // showTotal={(_, range) => `${range[0]}-${range[1]} از مجموع ${totalRecord} مورد`}
        />
      </Col>
      <Col xl={12} lg={12} md={12} sm={12} xs={24}>
        <Space
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: '100%',
          }}
        >
          تعداد کل {totalRecord}
        </Space>
      </Col>
    </Row>
  );
}
